import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const ArTooltip = ({ dayDifference }: { dayDifference: number }) => (
    <Tooltip
        className="vyne-ar-tooltip"
        placement="bottom"
        classNames={{ root: "vyne-ar-tooltip-content" }}
        title={
            <>
                <strong>
                    AR trend arrows show how your AR has changed over the past {dayDifference} day
                    {dayDifference !== 1 ? "s" : ""}
                </strong>
                <ul>
                    <li>Red ↑ means AR has increased</li>
                    <li>Green ↓ means AR has decreased</li>
                </ul>
                <strong>Why AR Cards May Not Exactly Match Your Outstanding Accounts List</strong>
                <p>
                    We know it can be confusing when numbers don&apos;t line up perfectly—don&apos;t worry, the system
                    is working as expected. Here are a few common reasons for the difference:
                </p>
                <ul>
                    <li>
                        A patient was already messaged but hasn&apos;t paid yet. They still affect AR but won&apos;t
                        appear in the outstanding list until reminders are completed.
                    </li>
                    <li>
                        A patient has balances across multiple aging buckets. They&apos;ll contribute to multiple cards
                        but only appear once in the list, which can affect sorting.
                    </li>
                    <li>
                        A patient has a credit on their account. Credits create a negative balance that affects AR
                        totals but don&apos;t qualify for payment requests.
                    </li>
                </ul>
                <p>Because of these scenarios, it&apos;s normal for the AR cards and outstanding list to differ.</p>
            </>
        }
    >
        <InfoCircleOutlined />
        AR Details
    </Tooltip>
);
